import {Component, OnInit} from '@angular/core';
import { PageScrollConfig } from 'ngx-page-scroll';
import {AppActionsDelegate} from './api/delegates/app-actions.delegate';

@Component({
  selector: 'stay-mgmt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'Stay Management Application';
  constructor(private _appActionsDelegate: AppActionsDelegate) {
    PageScrollConfig.defaultDuration = 790;
  }
  ngOnInit() {
    this._appActionsDelegate.bootstrap();
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/app.component.ts